export default "<narwhalia-exchange-sidebar class=\"sidebar\"></narwhalia-exchange-sidebar>\r\n<narwhalia-exchange-list></narwhalia-exchange-list>\r\n";